import { PaymentOptions } from '../enums';
import { UserRoleIndexModel } from './user-roles.model';

export interface CommercialManagerModel {
  id: number;
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  profileImageFileName: string;
  profileImageFileWebPath: string;
  isActive: boolean;
  isTemporalPassword: boolean;
  sendNotificationsByEmail: boolean;
  sendNotificationsByPhone: boolean;
  requesterCompanyId: number;
  supplierCompanyId: number;
  customerId: number;
  nationalIdentityDocument: string;
  paymentOptions: PaymentOptions;
  position: string;
  extract: string;
  roles: UserRoleIndexModel[];
}

export interface CommercialManagerEditModel {
  id: number;
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  isActive: boolean;
  requesterCompanyId: number;
  supplierCompanyId: number;
  customerId: number;
  nationalIdentityDocument: string;
  paymentOptions: PaymentOptions;
  sendNotificationsByEmail: boolean;
  sendNotificationsByPhone: boolean;
}

export interface CommercialManagerIndexModel {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  requesterCompanyId: number;
  supplierCompanyId: number;
  customerId: number;
  nationalIdentityDocument: string;
  appraisalsInProcessCount: number;
  position: string;
  extract: string;
}

export interface CommercialManagerFilterModel {
  summary: string;
  activatedFiltersCount: number;
  orderFieldName: string;
  orderFieldAsc: boolean;
  possibleOrderFieldNames: string[];
  id: number;
  ids: number[];
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  hasCustomerOrRequesterCompanyAssigned: boolean;
  customerId: number;
  customerIds: number[];
  requesterCompanyId: number;
  requesterCompanyIds: number[];
  supplierCompanyId: number;
  supplierCompanyIds: [];
  sendNotificationsByEmail: boolean;
  sendNotificationsByPhone: boolean;
  firstNameContains: string;
  lastNameContains: string;
  emailContains: string;
  fullName: string;
  fullNameContains: string;
  nationalIdentityDocument: string;
  nationalIdentityDocumentContains: string;
  position: string;
}
